export default [{ id: "Disinfezione" }, { id: 'AllPosts' }, { id: "Contatti" }]
